import styled from 'styled-components';
import { NoonReportTypeEnum } from '../../../types/BusinessModel/AolEnums';
import { NoonReportStatusEnum } from '../../../types/ViewModel/AolEnums';
import theme from 'src/theme';

type StyledProps = {
    isSelected?: boolean;
    noonReportType?: NoonReportTypeEnum;
    noonReportStatus?: NoonReportStatusEnum;
    isValid?: boolean;
};

export const TabButton = styled.div<StyledProps>`
    display: inline-flex;
    align-items: end;
    min-width: 115px;
    height: 50px;
    padding: 5px 5px 2px;
    margin: 0 1px 0 0;
    border-radius: 3px 3px 0 0;
    text-align: center;
    color: ${props => props.theme.colors.text.tabText};
    border: 1px solid ${props => props.theme.colors.background.grey};
    border-bottom: 0;
    cursor: pointer;
    position: relative;
    &:hover {
        background: #eee;
    }

    ${(props) => props.theme.noonReportTypeListMarker(props.noonReportType, props.isValid)}
    ${(props) => props.theme.selectableElement(props.isSelected)}
    .status-icon {
        margin-bottom: 4px;
    }
`;

export const TabText = styled.div`
    display: flex;
    margin-right: 0.25rem;
    flex-direction: column;
    justify-content: space-between;
    font-weight: 500;
    height: 100%;
    line-height: 1.4;
    @media only screen and (max-width: 1440px) {
        line-height: 1.25;
        font-size: 0.6rem;
    }
`;

export const LeftPanelWrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    grid-gap: 5px;
    margin: 0 5px;
`;

export const RightPanelWrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    grid-gap: 5px;
    margin: 0 5px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    grid-gap: 5px;
    margin: 0 5px;
    .full-width {
        grid-gap: 0;
    }
`;

export const PageContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 22.5% 1fr;
    height: 100%;
    width: 100%;
    grid-gap: 5px;
    margin: 0 5px;
`;

export const LeftWrapper = styled.div`
    box-shadow: #ccc 0 2px 6px 2px;
    height: calc(100% - 5px);
`;

export const LeftTopWrapper = styled.div`
    height: 50px;
    background: pink;
    display: flex;
`;

export const MainPanel = styled.div`
    position: relative;
    height: calc(100% - 5px);
    overflow: hidden;
    box-shadow: ${props => props.theme.colors.shadow.light} 0 2px 6px 2px;

    AolContainerComponent {
        height: calc(100% - 65px);
    }

    button {
        cursor: pointer;
    }
`;

export const PanelHeader = styled.div`
    font-size: 0.7rem;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        display: flex;
        justify-content: center;
        flex: 1;
        grid-gap: 10px;
    }

    .section-filter-button {
        justify-self: right !important;
    }

    .sections-list {
        button {
            border: 1px solid ${props => props.theme.colors.border.grey};
            background: ${props => props.theme.colors.background.grey};
            color: #fff;
            padding: 0.35rem 0.65rem;
            vertical-align: middle;
            line-height: 0.5rem;
            outline: 0;
            border-radius: 4px;
            margin: 2px;
        }
    }
`;

export const AolHeaderWrapper = styled(PanelHeader)`
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 2px;
    height: 60px;
    h3 {
        display: flex;
        justify-content: space-between;
        margin: 0 10px;
        font-size: 1rem;
        border-bottom: 2px solid ${theme.legacyColors.darkBlue};
        padding: 0.5rem 2rem;
        top: 9px;
        right: 215px;
        position: absolute;
        width: 260px;
    }
`;

export const FilterWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const FilterLeftWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-gap: 10px;
`;

export const FilterLeftWrapperContent = styled.div`
    display: block;
    .info-text {
        font-size: 0.7rem;
        font-weight: 400;
    }
`;

export const FilterRightWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
    align-self: center;
`;

export const ClearFilterIconWrapper = styled.div`
    cursor: pointer;
    color: ${theme.legacyColors.darkBlue};
    margin-left: 5px;
`;

export const FilterOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-left: 10px;
    padding-top: 5px;
`;

export const FromToWrapper = styled.span`
    display: flex;
    justify-content: flex-start;
    padding-left: 2px;
`;

export const AolSectionWrapper = styled.div`
    padding: 1rem;
`;

export const SectionFilterWrapper = styled.div`
    padding: 1rem;
    position: absolute;
    background: ${props => props.theme.colors.background.hover.default};
    top: 3rem;
    right: 0;
    width: 35%;
    border: solid 1px ${props => props.theme.colors.border.light};

    button {
        margin: 0.05rem;
    }
`;

export const ErrorEventsWrapper = styled.div`
    color: ${props => props.theme.colors.background.error};
    display: inline-block;
    border: 1px solid ${props => props.theme.colors.border.error};
    margin: 10px;

    h3 {
        color: #fff;
        padding: 5px 10px;
        background: ${(props) => props.theme.colors.status.mismatch};
    }

    .error-row {
        padding: 5px 10px;
    }

    .event-type {
        display: inline-block;
        width: 8rem;
    }
`;

export const ErrorContentRow = styled.div`
    display: flex;
    align-items: end;

    button {
        margin-left: 0.5rem;
    }
`;

export const ConfirmDeleteAol = styled.div`
    position: absolute;
    right: 5px;
    bottom: -160px;
    height: 150px;
    width: 250px;
    z-index: 10;
    background: #fff;
    text-align: center;
    box-shadow: 0 2px 6px 0 ${props => props.theme.colors.shadow.light};
    font-size: 0.9rem;

    h5 {
        margin: -5px 0px 10px;
        font-size: 0.9rem;
        font-weight: 500;
        background: #eee;
        padding: 10px;
        margin: -5px 0 10px 0;
        font-size: 0.9rem;
        font-weight: 500;
        font-size: 0.9rem;
        font-weight: 500;
        color: ${theme.legacyColors.error};
    }
`;

export const ValidationContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
`;

export const UpdateInfoWrapper = styled.div`
    font-size: 0.6rem;
    font-weight: 400;
    display: grid;
    margin: 0 15px;
    padding: 7px 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    grid-template-columns: 75px 115px 165px;
    @media only screen and (max-width: 1440px) {
        grid-template-columns: 65px 25px 25px;
    }

    @media print {
        display: none;
    }

    &.print {
        display: none;
        @media print {
            display: grid;
            grid-template-columns: 75px 200px 150px;
        }
    }

    .clock-icon,
    .profile-icon {
        margin: 0 5px 0 0;
        color: #04265a;
    }

    .clock-icon {
        margin: 0 5px 0 5px;
    }

    .user-info,
    .time-info {
        @media only screen and (max-width: 1440px) {
            display: none;
        }
    }
`;

export const MrvVerifiedIcon = styled.div`
    font-size: 0.75rem;
    margin-bottom: -35px;
    span {
        color: ${props => props.theme.colors.text.mrvVerified};
        margin-left: 3px;
    }
`;
